/**
 * Model definition for Meta
 */
export interface InternMeta {
  __component: 'intern.meta';
  id: string;
  title?: string;
  description?: string;
  noindex?: boolean;
  nofollow?: boolean;
  ld?: { [key: string]: unknown };
}

export function isInternMeta(obj: { __component?: string }): obj is InternMeta {
  return obj.__component === 'intern.meta';
}
